/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageAdd',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    ValueList     = require('mag-component-value-list'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    ModalMessage  = require('mag-component-modal'),
    RadioList     = require('mag-component-radio-list'),
    Button        = require('stb-component-button'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    tools         = require('../modules/tools'),
    Flicker       = require('spa-component-flicker'),
    pvr           = window.core.plugins.pvr,
    pvrErrorCodes = {
        '-1': gettext('Wrong record parameters.'),
        '-2': gettext('Not enough memory.'),
        '-3': gettext('Wrong record range. Record lenth must be less than or equal 24 hours.'),
        '-4': gettext('Task with specified ID was not found.'),
        '-5': gettext('Wrong file name. Folder where you want to save recording must exist.'),
        '-6': gettext('Record with that name already exists.'),
        '-7': gettext('Error opening stream URL.'),
        '-8': gettext('Error opening file.'),
        '-9': gettext('Maximum number of simultaneous recording is exceeded.'),
        '-10': gettext('Records app got a thread exit notification. File record is over.'),
        '-11': gettext('Error writing file. Probably the disk is full or has been disconnected during recording.'),
        '-12': gettext('Wrong record url.'),
        '-13': gettext('Wrong file name.'),
        '-14': gettext('Wrong record start time.'),
        '-15': gettext('Wrong record end time.'),
        '-16': gettext('Bad record.')
    },
    spvr, spvrErrorCodes;


if ( MODE === 'MINISTRA' ) {
    // stalker have server pvr so we can use it
    spvr = window.core.plugins.spvr;
    app.spvr = spvr;
    spvrErrorCodes = {
        '-1': gettext('Wrong channel id.'),
        '-2': gettext('Server error.'),
        '-3': gettext('Bad record.')
    };
}

app.pvr = pvr;

page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();

function dateKeydown ( event, myself ) {
    ValueList.prototype.defaultEvents.keydown.call(myself, event);
    if ( event.code === keys.ok ) {
        myself.parent.emit('click');
    }
}

function dateRender ( $body, myself ) {
    if ( $body.children.length > 1 ) {
        $body.children[1].innerText = myself.current ? myself.current.value : 0;
    } else {
        $body.appendChild(dom.tag('div', {className: 'pointerWrapper'}));
        $body.appendChild(dom.tag('div', {className: 'text'}, myself.current ? myself.current.value : 0));
        $body.appendChild(
            dom.tag(
                'div',
                {className: 'pointerWrapper'},
                dom.tag('div', {className: 'dateInputHint'})
            )
        );
    }
}

function getIndex ( value, data ) {
    return data.indexOf(value < 10 ? '0' + value : '' + value);
}

// modal message: select device
page.modalSelectDevice = new ModalMessage({
    title: gettext('devices'),
    className: 'modalSelectDevice',
    visible: false,
    events: {
        show: function () {
            var allowStorage = app.intent ? app.intent.data.pvr.local : true,
                allowServer  = app.intent ? app.intent.data.pvr.server : true,
                body         = [],
                focusIndex   = 0,
                index;

            if ( MODE === 'MINISTRA' && allowServer && spvr.enabled ) {
                body = [{state: true, title: gettext('Server'), value: 'Server'}];
            }
            if ( allowStorage ) {
                for ( index = 0; index < app.storages.length; index++ ) {
                    body.push({state: false, title: app.storages[index].label, value: app.storages[index]});
                    if ( page.currStorage && page.currStorage.mountPath === app.storages[index].mountPath ) {
                        body[0].state = false;
                        body[body.length - 1].state = true;
                        focusIndex = Number(body.length - 1);
                    }
                }
            }

            this.children[0].init({data: body, size: body.length, focusIndex: focusIndex});
            this.focus();
        },
        hide: function () {
            page.panelSet.focus();
        }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 3,
            data: [],
            propagate: true,
            events: {
                'click:item': function ( event ) {
                    page.modalSelectDevice.hide();
                    page.panelSet.reset({storage: event.$item.data.value});
                }
            }
        })
    ]
});
page.add(page.modalSelectDevice);


// panel: add new record
page.panelAdd = new PanelExtended({
    title: gettext('new record'),
    main: true,
    visible: true,
    className: 'panelAdd'
});

page.panelAdd.add(page.panelAdd.list = new LayoutList({
    focusIndex: 0,
    size: 5,
    events: {
        overflow: function () {
            page.panelAdd.list.$focusItem.classList.remove('focus');
            page.panelAdd.button.focus();
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        }
    },
    data: [
        {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('Channel:')},
                {className: 'item text', value: ''},
                {className: 'item placeholder theme-item-more', value: ''}
            ],
            click: function () {
                app.route(app.pages.chans);
            }
        },
        {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('Start time:')},
                page.panelAdd.startHour = new ValueList({
                    data: tools.dates.hours.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: ':'},
                page.panelAdd.startMinute = new ValueList({
                    data: tools.dates.minutes.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: ' '},
                page.panelAdd.startDay = new ValueList({
                    data: tools.dates.days.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: '/'},
                page.panelAdd.startMonth = new ValueList({
                    data: tools.dates.months.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: '/'},
                page.panelAdd.startYear = new ValueList({
                    data: tools.dates.years.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'lastPadding', value: ' '}
            ]
        },
        {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('End time:')},
                page.panelAdd.endHour = new ValueList({
                    data: tools.dates.hours.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: ':'},
                page.panelAdd.endMinute = new ValueList({
                    data: tools.dates.minutes.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: ' '},
                page.panelAdd.endDay = new ValueList({
                    data: tools.dates.days.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: '/'},
                page.panelAdd.endMonth = new ValueList({
                    data: tools.dates.months.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'separator', value: '/'},
                page.panelAdd.endYear = new ValueList({
                    data: tools.dates.years.slice(),
                    cycle: true,
                    events: {
                        keydown: function ( event ) { dateKeydown(event, this); }
                    },
                    render: function ( $element ) { dateRender($element, this); }
                }),
                {className: 'lastPadding', value: ' '}
            ]
        },
        {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('Storage:')},
                {className: 'item text', value: gettext('Recording not allowed')},
                {className: 'item placeholder theme-item-more', value: ''}
            ],
            click: function () {
                var allowStorage = app.intent ? app.intent.data.pvr.local : true,
                    allowServer  = app.intent ? app.intent.data.pvr.server : true;

                if (
                    (app.storages.length && allowStorage)
                    || (allowServer && MODE === 'MINISTRA' && spvr && spvr.enabled)
                ) {
                    page.panelSet.blur();
                    page.modalSelectDevice.show();
                    page.panelSet.visible = false;
                }
            }
        },
        {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('File name:')},
                page.panelAdd.input = dom.tag('div', {className: 'item text'}, gettext('Type here')),
                {className: 'item placeholder theme-item-editable', value: ''}
            ],
            click: function () {
                window.core.intent({
                    action: 'keyboard',
                    data: {
                        type: 'text',
                        mode: 'qwerty',
                        title: gettext('ENTER FILE NAME'),
                        description: gettext('RECORDS'),
                        value: page.panelAdd.input.innerText
                    },
                    events: {
                        done: function ( event ) {
                            page.panelAdd.input.innerText = event.value;
                        }
                    }
                }, function ( error ) {
                    console.log(error);
                });
            }
        }
    ]
}));
// add hints for start time
page.panelAdd.startHour.$node.children[2].children[0].innerText = 'hh';
page.panelAdd.startMinute.$node.children[2].children[0].innerText = 'mm';
page.panelAdd.startDay.$node.children[2].children[0].innerText = 'DD';
page.panelAdd.startMonth.$node.children[2].children[0].innerText = 'MM';
page.panelAdd.startYear.$node.children[2].children[0].innerText = 'YYYY';
// add hints for end time
page.panelAdd.endHour.$node.children[2].children[0].innerText = 'hh';
page.panelAdd.endMinute.$node.children[2].children[0].innerText = 'mm';
page.panelAdd.endDay.$node.children[2].children[0].innerText = 'DD';
page.panelAdd.endMonth.$node.children[2].children[0].innerText = 'MM';
page.panelAdd.endYear.$node.children[2].children[0].innerText = 'YYYY';


page.panelAdd.add(page.panelAdd.button = new Button({
    value: gettext('Create'),
    className: 'bottom theme-footer',
    $node: page.panelAdd.$node.appendChild(document.createElement('div')),
    events: {
        click: function () {
            var name      = app.intent ? app.intent.data.name : '',
                uri       = app.intent ? app.intent.data.uri : '',
                recordId  = app.intent ? app.intent.data.id : '',
                startDate = new Date(
                    page.panelAdd.startYear.current.value,
                    page.panelAdd.startMonth.current.value - 1,
                    page.panelAdd.startDay.current.value,
                    page.panelAdd.startHour.current.value,
                    page.panelAdd.startMinute.current.value
                ),
                endDate   = new Date(
                    page.panelAdd.endYear.current.value,
                    page.panelAdd.endMonth.current.value - 1,
                    page.panelAdd.endDay.current.value,
                    page.panelAdd.endHour.current.value,
                    page.panelAdd.endMinute.current.value
                ),
                path;

            if ( startDate.getMonth() + 1 !== parseInt(page.panelAdd.startMonth.current.value, 10) ) {
                window.core.notify({title: gettext('Wrong record start time.'), icon: 'alert', type: 'warning'});

                return;
            }
            if ( endDate.getMonth() + 1 !== parseInt(page.panelAdd.endMonth.current.value, 10) ) {
                window.core.notify({title: gettext('Wrong record end time.'), icon: 'alert', type: 'warning'});

                return;
            }
            if ( startDate.getTime() >= endDate.getTime() ) {
                window.core.notify({
                    title: gettext('Wrong record range. Record lenth must be less than or equal 24 hours.'),
                    icon: 'alert',
                    type: 'warning'
                });

                return;
            }
            // check if storage have free space
            if ( page.currStorage && Number(page.currStorage.freeSize) === 0 ) {
                window.core.notify({
                    title: gettext('Not enough free space in storage'),
                    icon: 'alert',
                    type: 'warning'
                });

                return;
            }
            // write to storage
            if ( page.currStorage && page.currStorage.label ) {
                path = page.currStorage.mountPath + '/records/' + name + '/';
                path += page.panelAdd.startYear.current.value + '-' + page.panelAdd.startMonth.current.value + '-';
                path += page.panelAdd.startDay.current.value + '/' + page.panelAdd.input.innerText + '.ts';
                pvr.add({
                    name: path,
                    channel: uri,
                    startTime: Math.ceil(startDate.getTime() / 1000),
                    endTime: Math.ceil(endDate.getTime() / 1000)
                }, function ( item, error ) {
                    if ( error ) {
                        window.core.notify({title: pvrErrorCodes[error.code], icon: 'alert', type: 'warning'});
                    } else {
                        if ( app.intent && app.intent.close ) {
                            app.intent.close();
                            app.intent = null;
                        }
                        app.route(app.pages.main);
                    }
                });
            } else if ( MODE === 'MINISTRA' && page.currStorage === 'Server' && spvr.enabled ) {
                // or to server
                spvr.add({
                    id: recordId,
                    startTime: Math.ceil(startDate.getTime() / 1000),
                    endTime: Math.ceil(endDate.getTime() / 1000)
                }, function ( error ) {
                    //console.log('add callback called');
                    if ( error ) {
                        console.log('error.code' + error.code + '  typeof ' + typeof error.code + ' error.message:' + error.message);
                        if ( spvrErrorCodes[error.code] ) {
                            // show our own custom localised error message
                            core.notify({title: spvrErrorCodes[error.code], icon: 'alert', type: 'warning'});
                        } else {
                            // or use default one
                            core.notify({title: error.message, icon: 'alert', type: 'warning'});
                        }
                    } else {
                        if ( app.intent && app.intent.close ) {
                            app.intent.close();
                            app.intent = null;
                        }
                        app.route(app.pages.main);
                    }
                });
            } else if ( page.currStorage === null ) {
                window.core.notify({title: gettext('No storage device.'), icon: 'alert', type: 'warning'});
            } else {
                window.core.notify({title: gettext('Recording not allowed'), icon: 'alert', type: 'warning'});
            }
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                page.panelAdd.list.$focusItem.classList.add('focus');
                page.panelAdd.list.focus();
                page.panelAdd.list.focusIndex(page.panelAdd.list.data.length - 1);
            } else if ( event.code === keys.down ) {
                page.panelAdd.list.$focusItem.classList.add('focus');
                page.panelAdd.list.focus();
                page.panelAdd.list.focusIndex(0);
            } else if ( event.code === keys.ok ) {
                if ( page.panelAdd.button.events['click'] ) {
                    page.panelAdd.button.emit('click', {event: event});
                }
            }
        }
    }
}));

// panel set: add record
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetAdd'),
    focusIndex: 0,
    panels: [page.panelAdd]
});
page.panelSet.reset = function ( config ) {
    var $text, free, all,
        $textWrapper = page.panelAdd.list.$body.children[3].children[0].children[1],
        allowStorage = app.intent ? app.intent.data.pvr.local : true,
        allowServer  = app.intent ? app.intent.data.pvr.server : true;

    if ( config && config.storage && config.storage.size && allowStorage ) {
        // selected storage
        free = gettext('Free space:') + ' ' + tools.convert(config.storage.freeSize);
        all = tools.convert(config.storage.size);
        $text = dom.fragment(
            dom.tag('div', {className: 'itemHalf'}, config.storage.label),
            dom.tag('div', {className: 'itemHalf'}, free + gettext(' of ') + all)
        );
        page.currStorage = config.storage;
    } else if ( MODE === 'MINISTRA' && allowServer && spvr && spvr.enabled ) {
        // server by default (if allowed)
        $text = document.createTextNode(gettext('Server'));
        page.currStorage = 'Server';
    } else if ( allowStorage && app.storages.length ) {
        // first storage by default (if allowed)
        free = gettext('Free space:') + ' ' + tools.convert(app.storages[0].freeSize);
        all = tools.convert(app.storages[0].size);
        $text = dom.fragment(
            dom.tag('div', {className: 'itemHalf'}, app.storages[0].label),
            dom.tag('div', {className: 'itemHalf'}, free + gettext(' of ') + all)
        );
        page.currStorage = app.storages[0];
    } else if ( allowStorage ) {
        // no storage (if allowed)
        $text = document.createTextNode(gettext('No storage device.'));
        page.currStorage = null;
    } else {
        // nothing is allowed
        $text = document.createTextNode(gettext('Recording not allowed'));
        page.currStorage = undefined;
    }
    while ( $textWrapper.firstChild ) {
        $textWrapper.removeChild($textWrapper.firstChild);
    }
    $textWrapper.appendChild($text);
    page.panelAdd.list.$focusItem.classList.add('focus');
    page.panelAdd.list.focus();
};
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            if ( app.intent && app.intent.close ) {
                app.intent.close();
                app.intent = null;
            }
            app.route(app.pages.main);
            break;
    }
});

page.reset = function () {
    // merge option tell us to left, if possible, all fields as they were
    var merge       = app.intent && app.intent.data.merge,
        channelName = app.intent ? app.intent.data.name : gettext('Select channel'),
        start       = new Date(),
        end         = new Date(
            start.getFullYear(),
            start.getMonth(),
            start.getDate(),
            start.getHours() === 23 ? 0 : start.getHours() + 1,
            start.getMinutes()
        ),
        minutes     = tools.dates.minutes.slice(),
        hours       = tools.dates.hours.slice(),
        days        = tools.dates.days.slice(),
        months      = tools.dates.months.slice(),
        years       = tools.dates.years.slice(),
        fileName;

    if ( app.intent && app.intent.data.startTime ) {
        start.setTime(app.intent.data.startTime * 1000);
        end.setTime(app.intent.data.endTime * 1000);
    }
    // set channel name
    page.panelAdd.list.$body.children[0].children[0].children[1].innerText = channelName;
    if ( !merge ) {
        // set start time
        page.panelAdd.startMinute.init({data: minutes.slice(), index: getIndex(start.getMinutes(), minutes.slice())});
        page.panelAdd.startHour.init({data: hours.slice(), index: getIndex(start.getHours(), hours.slice())});
        page.panelAdd.startDay.init({data: days.slice(), index: getIndex(start.getDate(), days.slice())});
        page.panelAdd.startMonth.init({data: months.slice(), index: getIndex(start.getMonth() + 1, months.slice())});
        page.panelAdd.startYear.init({data: years.slice(), index: getIndex(start.getFullYear(), years.slice())});
        // set end time
        page.panelAdd.endMinute.init({data: minutes.slice(), index: getIndex(end.getMinutes(), minutes.slice())});
        page.panelAdd.endHour.init({data: hours.slice(), index: getIndex(end.getHours(), hours.slice())});
        page.panelAdd.endDay.init({data: days.slice(), index: getIndex(end.getDate(), days.slice())});
        page.panelAdd.endMonth.init({data: months.slice(), index: getIndex(end.getMonth() + 1, months.slice())});
        page.panelAdd.endYear.init({data: years.slice(), index: getIndex(end.getFullYear(), years.slice())});
        // set file name
        fileName = page.panelAdd.startHour.current.value + '-' + page.panelAdd.startMinute.current.value + '-';
        fileName += (start.getSeconds() < 10 ? '0' + start.getSeconds() : start.getSeconds());
        page.panelAdd.input.innerText = fileName;
    }
    // hide modal
    if ( page.modalSelectDevice.visible ) {
        page.modalSelectDevice.hide();
        page.panelSet.focus();
    }
    // set default storage
    page.panelSet.reset(merge && page.currStorage && page.currStorage.freeSize ? {storage: page.currStorage} : null);
};

page.addListener('show', function () {
    page.reset();
    page.panelSet.focus();
});


// public
module.exports = page;
